/**
 * @fileoverview PUT handler for the "/engagement/campaigns/campaign_alert_preferences_update" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsCampaignAlertPreferencesUpdateCacheKeys } from "./constants";
import type {
  EngagementCampaignsCampaignAlertPreferencesUpdateResult,
  PutEngagementCampaignsCampaignAlertPreferencesUpdate,
} from "./types";

export const putEngagementCampaignsCampaignAlertPreferencesUpdate = reactQueryMutationAdapter(
  engagementCampaignsCampaignAlertPreferencesUpdateCacheKeys,
  (
    props: PutEngagementCampaignsCampaignAlertPreferencesUpdate
  ): Promise<EngagementCampaignsCampaignAlertPreferencesUpdateResult> => {
    return fetch("/engagement/campaigns/campaign_alert_preferences_update", "PUT", props);
  }
);
